import { Formik, Form as FormikForm, Field, FieldArray } from "formik";
import React from "react";
import { Form, Spinner } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useTemplateCategoryShowQuery,
  useUpdatePositionTemplatesMutation,
} from "../../../graphql/templateCategory.hooks";

interface TemplatesOrder {
  id: number;
  name: string;
  position: number;
}

interface ITemplateValues {
  templates: TemplatesOrder[];
}

export const ShowTemplateCategory = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const { data: category, loading: categoryLoading } =
    useTemplateCategoryShowQuery({
      variables: { templateCategory: +categoryId },
    });

  const [updatePositionTemplates, { loading: loadingUpdatePositionTemplates }] =
    useUpdatePositionTemplatesMutation();

  const backToList = () => {
    navigate("/template/category");
  };

  const handleSubmit = (values: ITemplateValues) => {
    const templatesPriority = values.templates.map((item) => ({
      templateId: item.id,
      priority: item.position,
    }));
    updatePositionTemplates({ variables: { templatesPriority } });
  };

  if (categoryLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const initialValues: ITemplateValues = {
    templates: category.templateCategoryShow.templates
      .filter((item) => item.isCommon)
      .map(({ id, name, position }) => ({
        id,
        name: name || "",
        position: position || 0,
      })),
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Template Category</h1>
          <p className="text-nowrap fs-4">
            Title: {category?.templateCategoryShow.title} Id:{" "}
            {category?.templateCategoryShow.id}
          </p>
        </div>
      </div>
      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values }) => (
            <FormikForm className="w-100">
              <table className="col-11 mb-5 m-auto">
                <thead>
                  <tr>
                    <th className="d-none d-md-block">Id</th>
                    <th>Title</th>
                    <th className="text-center">Actions</th>
                    <th className="text-center">Order</th>
                  </tr>
                </thead>
                <tbody>
                  <FieldArray name="templates">
                    {() =>
                      values.templates.map((template, index) => (
                        <tr key={template.id} style={{ lineHeight: "2" }}>
                          <td className="d-none d-md-table-cell">
                            {template.id}
                          </td>
                          <td>{template.name}</td>
                          <td className="text-center">
                            <Link
                              to={`/template/${template.id}`}
                              className="text-primary me-4"
                              style={{ textDecoration: "none" }}
                            >
                              Show
                            </Link>
                            <Link
                              to={`/template/${template.id}/edit`}
                              className="text-primary"
                              style={{ textDecoration: "none" }}
                            >
                              Settings
                            </Link>
                          </td>
                          <td>
                            <Field
                              name={`templates[${index}].position`}
                              type="number"
                              placeholder="Order"
                              as={Form.Control}
                              min="0"
                              style={{ maxWidth: 100 }}
                              className="m-auto"
                            />
                          </td>
                        </tr>
                      ))
                    }
                  </FieldArray>
                  {!category.templateCategoryShow.templates.length && (
                    <p className="mt-3">No templates Found</p>
                  )}
                  <tr></tr>
                </tbody>
              </table>
              <div className="d-flex flex-column flex-md-row justify-content-between col-11 col-md-8 m-auto">
                <button
                  onClick={backToList}
                  className="btn btn-primary text-white col-12 col-md-4 me-md-4 mb-2 mb-md-0"
                >
                  Back To List
                </button>
                <button
                  type="submit"
                  className="btn btn-primary text-white col-12 col-md-4 me-md-4 mb-2 mb-md-0"
                  disabled={loadingUpdatePositionTemplates}
                >
                  Save {loadingUpdatePositionTemplates && <Spinner />}
                </button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};
